<template>
    <LoginUserName v-if="pageIndex == 0" :vModel="vModel"></LoginUserName>
    <LoginPassPhrase v-else-if="pageIndex == 1" :vModel="vModel"> </LoginPassPhrase>
    <LoginPassWord v-else-if="pageIndex == 2" :vModel="vModel"> </LoginPassWord>
</template>

<script>
    import authservice from "../../services/authservice";
    import commonService from "../../services/common";
    import LoginUserName from "./loginUserName.vue";
    import LoginPassPhrase from "./loginPassPhrase.vue";
    import LoginPassWord from "./loginPassword.vue";

    export default {
        name: "login",
        components: {
            LoginUserName,
            LoginPassPhrase,
            LoginPassWord,
        },

        created() {
            if (this.pageIndex == null) {
                this.pageIndex = 0;
            }
        },
        provide() {
            return {
                $validator: this.$validator,
            }
        },

        data() {
            return {
                windowAlive: null,
                vModel: {
                    Email: null,
                    Phone: null,
                    username: null,
                    password: null,
                    mykad: null,
                    passphrase: null,
                    HasPassPhrase: false,
                    IsRegisterComplete: false,
                    tabIndex: 0,

                    HasLoginErrorMessage: false,
                    LoginAttemptErrorMessage: '',

					loading: false
                },
                socialLoginModel: {
                    FirstName: null,
                    MiddleName: null,
                    LastName: null,
                    Email: null,
                    AppId: null,
                    Network: null,
                    DeviceIdentifier: null
                },
                isProcessing: false,
				pageIndex: 0,
            };
        },
        beforeRouteEnter(to, from, next) {
            commonService.destroyStorage();
            if (window.__sessionInterval != null)
                clearInterval(window.__sessionInterval);

            next();
        },
        methods: {
            // auth(network) {
            //     this.$validator.reset();
            //     this.errors.clear();
            //     if (this.isProcessing)
            //         return;
            //     var self = this;
            //     const hello = this.hello;
            //     hello(network).login({
            //         scope: 'email'
            //     }).then(() => {
            //         const authRes = hello(network).getAuthResponse();
            //         hello(network).api('me').then(function (json) {

            //             self.setSocialLoginModel(json, network);
            //             if (self.socialLoginModel.Email == '') {
            //                 self.sendtoregistration();
            //             } else {
            //                 var guid = authservice.createGuid();
            //                 self.socialLoginModel.DeviceIdentifier = guid;
            //                 self.isProcessing = true;
            //                 self.$http.post('account/social/login', self.socialLoginModel).then(response => {
            //                     self.isProcessing = false;
            //                     var result = response.body;
            //                     if (result.StatusCode == 0) { //user exists
            //                         commonService.setStorage('token', result.LoginInfo.DeviceKey);
            //                         commonService.setStorage('name', result.LoginInfo.Name);
            //                         commonService.setStorage('refreshToken', result.LoginInfo.RefreshToken);
            //                         commonService.setStorage('completeRegistration', result.LoginInfo.CompleteRegistration.toString());
            //                         commonService.setStorage('phoneNumberConfirmed', result.LoginInfo.PhoneNumberConfirmed.toString());
            //                         commonService.setStorage('countryFlag', result.LoginInfo.CountryFlag);
            //                         commonService.setStorage('lastLoginDate', result.LoginInfo.LastLogin);
            //                         commonService.setStorage('userKycStatus', result.LoginInfo.UserKycStatus);
            //                         commonService.setStorage('ekycEnable', result.LoginInfo.EkycEnable.toString());
            //                         commonService.setStorage('ipAddress', result.LoginInfo.IPAddress);
            //                         commonService.setStorage('emailAddressConfirmed', result.LoginInfo.EmailAddressConfirmed.toString());
            //                         commonService.setStorage('isVerifiedEKYCUser', result.LoginInfo.IsVerifiedEKYCUser.toString());
            //                         commonService.setStorage('isUnVerifiedKYCUser', result.LoginInfo.IsUnVerifiedKYCUser.toString());
            //                         commonService.setStorage('forceChangePhoneNumber', result.LoginInfo.ForceChangePhoneNumber.toString());
            //                         commonService.setStorage('forceChangePassword', result.LoginInfo.ForceChangePassword.toString());
            //                         commonService.setStorage('userDetail', JSON.stringify(result.LoginInfo.UserDetail));
            //                         commonService.setStorage('addressValidation', JSON.stringify(result.LoginInfo.AddressValidationCheck));
            //                         commonService.setStorage('GMapAPIKey_JS', result.LoginInfo.GMapAPIKey_JS);

            //                         if (result.LoginInfo.Message !== "") {
            //                             kendo.confirm("Your session has already been started. Logged on IP:" + result.LoginInfo.Message).then(
            //                                 function () {
            //                                     self.$http.post("account/killsession");
            //                                     authservice.setCookies(guid);
            //                                     self.$router.push('/dashboard');
            //                                     authservice.checkSession();
            //                                 },
            //                                 function () {
            //                                     commonService.destroyStorage();
            //                                 });
            //                         } else {
            //                             authservice.setCookies(guid);
            //                             self.$router.push('/dashboard');
            //                             authservice.checkSession();
            //                         }
            //                     } else { //send to registration
            //                         self.sendtoregistration();
            //                     }
            //                 }, error => {
            //                     self.isProcessing = false;
            //                 });
            //             }
            //         });
            //     })
            // },
            sendtoregistration() {
                commonService.setStorage('socialLoginDetail', JSON.stringify(this.socialLoginModel));
                this.$router.push('/account/registration/initial');
            },
            // setSocialLoginModel(json, network) {
            //     this.socialLoginModel.FirstName = json.first_name;
            //     this.socialLoginModel.MiddleName = json.hasOwnProperty('middle_name') ? json.middle_name : null;
            //     this.socialLoginModel.LastName = json.last_name;
            //     this.socialLoginModel.Email = json.email;
            //     this.socialLoginModel.AppId = json.id;
            //     this.socialLoginModel.Network = network;
            // },
            randomString() {
                var S4 = function () {
                    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
                };
                return (S4() + S4() + "" + S4() + "" + S4() + "" + S4() + "" + S4() + S4() + S4());

            },
            onSubmit() {
                if (this.isProcessing)
                    return;

                this.$validator.validateAll().then(result => {
                    if (result) {
                        authservice.signIn(this.vModel.username, this.vModel.password);
                    }
                });
            },
            onUserNameSubmit: function () {
                var self = this;
                if(self.vModel.Phone != null && self.vModel.Phone.length < 9)
                    return;
                self.vModel.username = self.vModel.tabIndex == 0 ? "60" + self.vModel.Phone : self.vModel.Email
                if (self.isProcessing)
                    return;

                self.$validator.validateAll().then(result => {
                    if (result) {
                        self.isProcessing = true;

                        self.$http.post('v2/account/passphrase/username', {
                            UserName: self.vModel.username

                        }).then(response => {
                            self.isProcessing = false;
                            var result = response.body;
                            commonService.setStorage('forget-password-show-dob', result.IsRegisterComplete);
                            self.vModel.passphrase = result.PassPhrase;
                            self.vModel.HasPassPhrase = result.HasPassPhrase;
                            self.vModel.IsRegisterComplete = result.IsRegisterComplete;
                            self.pageIndex = 1; 
                        },
                            error => {
                                console.log(error);
                                self.isProcessing = false;
                            });

                    }
                });
            },
            onPassPhraseConfirm: function () {
                var self = this;
                self.pageIndex = 2;

            },
            onPassPhraseCancel: function () {
                var self = this;
                self.pageIndex = 0;
                self.vModel.passphrase = null;
                self.vModel.HasPassPhrase = null;
                self.vModel.IsRegisterComplete = null;
                self.vModel.username = null;
                self.vModel.Phone = null;
                self.vModel.Email = null;

            },
            onPasswordSubmit: function () {
                //Delete Global Banners show flag might have been set in dashboard
                window.bannersToShow = undefined;

				var self = this;
				self.vModel.loading = true;
                self.vModel.HasLoginErrorMessage = false;
                self.vModel.LoginAttemptErrorMessage = '';
                var guid = authservice.createGuid();

                self.$validator.validate("userpassword", self.vModel.password).then(result => {

                    if (result) {
						authservice.signIn(self.vModel.username, self.vModel.password, self.vModel.passphrase)
                            .then(response => {
                                var result = response.body;
                                if (!result.IsLoginSuccess) {

                                    self.vModel.HasLoginErrorMessage = true;
                                    self.vModel.LoginAttemptErrorMessage = result.AttemptsFailedMessage;
                                    self.$toastr("error", result.Message);

									self.vModel.loading = false;   
                                    return false;
                                }

                                commonService.setStorage('token', result.DeviceKey);
                                commonService.setStorage('name', result.Name);
                                commonService.setStorage('refreshToken', result.RefreshToken);
                                commonService.setStorage('completeRegistration', result.CompleteRegistration.toString());
                                commonService.setStorage('phoneNumberConfirmed', result.PhoneNumberConfirmed.toString());
                                commonService.setStorage('countryFlag', result.CountryFlag);
                                commonService.setStorage('lastLoginDate', result.LastLogin);
                                commonService.setStorage('EUIdleTime', parseInt(result.EUIdleTime) - 1);
                                commonService.setStorage('userKycStatus', result.UserKycStatus);
                                commonService.setStorage('ekycEnable', result.EkycEnable.toString());
                                commonService.setStorage('ipAddress', result.IPAddress);
                                commonService.setStorage('emailAddressConfirmed', result.EmailAddressConfirmed.toString());
                                commonService.setStorage('isVerifiedEKYCUser', result.IsVerifiedEKYCUser.toString());
                                commonService.setStorage('isUnVerifiedKYCUser', result.IsUnVerifiedKYCUser.toString());
                                commonService.setStorage('forceChangePhoneNumber', result.ForceChangePhoneNumber.toString());
                                commonService.setStorage('forceChangePassword', result.ForceChangePassword.toString());
                                commonService.setStorage('IsRequiredEkycBankDetail', result.IsRequiredEkycBankDetail.toString());
                                commonService.setStorage('IsPassPhraseRequired', result.IsPassPhraseRequired.toString());
                                commonService.setStorage('IsProfileUpdatedRequired', result.IsProfileUpdatedRequired.toString());
                                commonService.setStorage('IsIdIssueDateUpdatedRequired', result.IsIdIssueDateUpdatedRequired.toString());
                                commonService.setStorage('IdDetail', result.IdDetail.toString());
                                commonService.setStorage('userDetail', JSON.stringify(result.UserDetail));
                                commonService.setStorage('addressValidation', JSON.stringify(result.AddressValidationCheck));
                                commonService.setStorage('employeeIndustryCheck', JSON.stringify(result.EmployeeIndustryCheck));


                                authservice.setCookies(guid);
                                window.Vue.$router.push('/dashboard');
                                authservice.checkSession();

								//self.vModel.loading = false;                             

                            });
                    }

					//self.vModel.loading = false;
                });
            },

        }
    };
</script>
